<div fxLayout="column" fxLayoutAlign="start stretch" [hidden]="!ViewReady">
    <h2 class="mat-headline">Search</h2>
    <button type="button" mat-raised-button color="accent" *ngIf="SmallDisplay && SearchConducted" (click)="ToggleSearchPanel()">
        <span>{{ ShowingSearchPanel ? 'Hide' : 'Show' }} Search Options</span>
    </button>
    <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="!SmallDisplay || !SearchConducted || ShowingSearchPanel">
        <form [formGroup]="SearchForm" novalidate>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="33">
                    <app-form-label>Year: </app-form-label>
                    <mat-form-field appearance="outline" fxFlex>
                        <mat-select matInput formControlName="srchYear" placeholder="Year..." aria-label="Request Year Selection List">
                            <mat-option [value]="null">All</mat-option>
                            <mat-option *ngFor="let year of AllSchoolYears" [value]="year">{{ year | schoolYear }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="33">
                    <app-form-label>Issue: </app-form-label>
                    <mat-form-field appearance="outline" fxFlex>
                        <input matInput type="search" formControlName="srchIssueNum" placeholder="Request #" />
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="33">
                    <app-form-label>Subject:</app-form-label>
                    <mat-form-field appearance="outline" fxFlex>
                        <input type="search" matInput formControlName="srchSubject" placeholder="Subject..." />
                    </mat-form-field>
                </div>
            </div>
            <mat-expansion-panel>
                <mat-expansion-panel-header> <mat-panel-title>Advanced Search Options</mat-panel-title> </mat-expansion-panel-header>
                <div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="30px">
                        <!-- <div fxLayout="row" fxLayoutAlign="start center" *ngIf="User.CurrentRole !== 'BoardMember'">
                                    <app-form-label>Request Type:</app-form-label>
                                    <mat-form-field appearance="outline">
                                        <mat-select
                                            matInput
                                            formControlName="srchType"
                                            placeholder="Request Type..."
                                            aria-label="Request Type Selection List"
                                        >
                                            <mat-option [value]="null">All</mat-option>
                                            <mat-option [value]="0">Board Requests</mat-option>
                                            <mat-option [value]="1">Constituent Requests</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div> -->
                        <div
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            *ngIf="User.CurrentRole !== 'BoardMember' && SearchForm?.get('srchType')?.value === 0"
                            fxLayoutGap="15px"
                            fxFlex="33"
                        >
                            <app-form-label>Board Member:</app-form-label>
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-select
                                    matInput
                                    formControlName="srchBoardMember"
                                    placeholder="Choose board member..."
                                    aria-label="Request Board Member Selection List"
                                >
                                    <mat-option [value]="null">Choose board member...</mat-option>
                                    <mat-option *ngFor="let board of BoardMembers" [value]="board"
                                        >{{ board.LastName | titleCase }}, {{ board.FirstName | titleCase }} - District
                                        {{ board.District }}</mat-option
                                    >
                                </mat-select>
                            </mat-form-field>
                            <!-- <ng-container *ngIf="SearchForm?.get('srchType')?.value === '1'">
                                        <app-form-label>Constituent:</app-form-label>
                                        <mat-form-field appearance="outline">
                                            <mat-select
                                                matInput
                                                formControlName="srchSource"
                                                placeholder="Choose constituent..."
                                                aria-label="Request Constituent Selection List"
                                            >
                                                <mat-option [value]="null">Choose constituent...</mat-option>
                                                <mat-option *ngFor="let cons of Constituents" [value]="cons">{{ cons | titleCase }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </ng-container> -->
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="33">
                            <app-form-label>Priority:</app-form-label>
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-select
                                    matInput
                                    formControlName="srchPriority"
                                    placeholder="Priority..."
                                    aria-lavel="Request Priority Selection List"
                                >
                                    <mat-option [value]="null">All</mat-option>
                                    <mat-option value="1">1 - Urgent</mat-option>
                                    <mat-option value="2">2 - High</mat-option>
                                    <mat-option value="3">3 - Routine</mat-option>
                                    <mat-option value="4">4 - Low</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="30px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="33">
                            <app-form-label>School:</app-form-label>
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-select
                                    matInput
                                    formControlName="srchSchool"
                                    placeholder="School..."
                                    aria-label="Request School Selection List"
                                >
                                    <mat-option [value]="null">School...</mat-option>
                                    <mat-option *ngFor="let sch of AllSchools" [value]="sch.SchoolNumber"
                                        >{{ sch.SchoolName }} ({{ sch.SchoolNumber }})</mat-option
                                    >
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="33">
                            <app-form-label>District:</app-form-label>
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-select
                                    matInput
                                    formControlName="srchDistrict"
                                    placeholder="District..."
                                    aria-label="Request District Selection List"
                                >
                                    <mat-option [value]="null">All / District-Wide</mat-option>
                                    <mat-option *ngFor="let dist of ['1', '2', '3', '4', '5', '6', '7']" [value]="dist">{{
                                        dist
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="30px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="33">
                            <app-form-label>Category:</app-form-label>
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-select
                                    matInput
                                    formControlName="srchCategory"
                                    placeholder="Category..."
                                    aria-label="Request Category Selection List"
                                >
                                    <mat-option [value]="null">Category...</mat-option>
                                    <mat-option *ngFor="let cat of AllCategories" [value]="cat"
                                        ><span
                                            >{{ cat.CategoryDescription }}
                                            <span *ngIf="cat.CabinetMember"
                                                >({{ cat?.CabinetMember?.FirstName | titleCase }}
                                                {{ cat?.CabinetMember?.LastName | titleCase }})</span
                                            ></span
                                        ></mat-option
                                    >
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="30px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                            <app-form-label>Date between: </app-form-label>
                            <mat-form-field appearance="outline">
                                <input type="text" matInput formControlName="srchDateBegin" [matDatepicker]="srchDateBeginPicker" />
                                <mat-datepicker-toggle [for]="srchDateBeginPicker" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #srchDateBeginPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                            <app-form-label>And</app-form-label>
                            <mat-form-field appearance="outline">
                                <input type="text" matInput formControlName="srchDateEnd" [matDatepicker]="srchDateEndPicker" />
                                <mat-datepicker-toggle [for]="srchDateEndPicker" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #srchDateEndPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutGap="30px">
                        <!-- <div
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            fxLayoutGap="15px"
                            *ngIf="User.CurrentRole !== 'BoardMember' && User.CurrentRole !== 'Cabinet'"
                            fxFlex="33"
                        >
                            <app-form-label>Referred To:</app-form-label>
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-select
                                    matInput
                                    formControlName="srchReferredTo"
                                    placeholder="Referred To..."
                                    aria-label="Request Supervisor Selection List"
                                >
                                    <mat-option [value]="null">Referred To...</mat-option>
                                    <mat-option *ngFor="let user of ReferredToUsers" [value]="user.SAPID"
                                        >{{ user.LastName | titleCase }}, ({{ user.FirstName | titleCase }})</mat-option
                                    >
                                </mat-select>
                            </mat-form-field>
                        </div> -->
                    </div>
                </div>
            </mat-expansion-panel>
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" class="margin-top margin-bottom">
                <button type="button" mat-raised-button color="warn" (click)="ClearSearchForm()">Reset</button>
                <button type="button" mat-raised-button color="primary" (click)="HandleSearch()">Search</button>
            </div>
        </form>
    </div>
    <div class="dividerline" *ngIf="SearchConducted"></div>
    <div [hidden]="!SearchConducted">
        <table class="fullwidth" mat-table [dataSource]="SearchResultsData" matSort matSortActive="DueDate" matSortDirection="desc">
            <ng-container matColumnDef="RequestIssueNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Request #</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <span>{{ req.RequestIssueNumber | requestIssue: req.FiscalYear }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="BoardMember">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Board Member</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <span>{{ req.RequestorInfo?.FirstName | titleCase }} {{ req.RequestorInfo?.LastName | titleCase }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="DueDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Due</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <span *ngIf="req.DueDate">{{ req.DueDate | date: 'M/d/yyyy' }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="Priority">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Priority</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <span>{{ req.PriorityShortLabel || '' }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="Subject">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Subject</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <span>{{ req.Subject }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="CategoryLabel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Category</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <div>{{ req.CategoryLabel }}</div>
                    <div *ngIf="req.CategoryID != null">
                        <em>({{ req.CategoryID | categoryCabinet: AllCategories }})</em>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="StatusLabel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Status</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <div>{{ req.StatusLabel }}</div>
                    <div *ngIf="req.Completed || req.Cancelled">({{ req.DateClosed | date: 'M/d/yyyy' }})</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="OwnerName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Referred To</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <span [attr.title]="'SAPID: ' + req.OwnerSAPID" *ngIf="req.OwnerSAPID">{{ req.OwnerName }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="DateCreated">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Opened</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <span>{{ req.DateCreated | date: 'M/d/yyyy' }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="DateClosed">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Closed</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <span *ngIf="req.Completed || req.Cancelled">{{ req.DateClosed | date: 'M/d/yyyy' }}</span>
                    <span *ngIf="!req.Completed && !req.Cancelled">N/A</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Actions</th>
                <td mat-cell *matCellDef="let req" class="centered">
                    <button
                        type="button"
                        mat-raised-button
                        color="accent"
                        (click)="HandleView(req)"
                        [disabled]="req.Status === 'CANCEL'"
                    >
                        View
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="NoData">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let req" [attr.colspan]="VisibleHeaders?.length">
                    <em>No search results found with selected search options.</em>
                </td>
            </ng-container>

            <ng-container matColumnDef="SmallDisplay">
                <th mat-header-cell *matHeaderCellDef>Search Results</th>
                <td mat-cell *matCellDef="let req">
                    <div fxLayout="column" fxLayoutAlign="start stretch">
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <div><strong>Request #</strong></div>
                            <span>{{ req.RequestIssueNumber | requestIssue: req.FiscalYear }}</span>
                        </div>
                        <div
                            *ngIf="User.CurrentRole !== 'BoardMember' && User.CurrentRole !== 'BoardAssistant'"
                            fxLayout="row"
                            fxLayoutAlign="space-between start"
                        >
                            <app-form-label>Board Member</app-form-label>
                            <span>{{ req.RequestorInfo?.FirstName | titleCase }} {{ req.RequestorInfo?.LastName | titleCase }}</span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <div><strong>Due</strong></div>
                            <span *ngIf="req.DueDate">{{ req.DueDate | date: 'M/d/yyyy' }}</span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <div><strong>Priority</strong></div>
                            <span>{{ req.PriorityShortLabel || '' }}</span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <div><strong>Subject</strong></div>
                            <span>{{ req.Subject }}</span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <div><strong>Category</strong></div>
                            <div fxLayout="column" fxLayoutAlign="start end">
                                <div>{{ req.CategoryLabel }}</div>
                                <div *ngIf="req.CategoryID != null">
                                    <em>({{ req.CategoryID | categoryCabinet: AllCategories }})</em>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <div><strong>Status</strong></div>
                            <div fxLayout="column" fxLayoutAlign="start end">
                                <span>{{ req.StatusLabel }}</span>
                                <div *ngIf="req.Completed || req.Cancelled">({{ req.DateClosed | date: 'M/d/yyyy' }})</div>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <div><strong>Referred To</strong></div>
                            <span [attr.title]="'SAPID: ' + req.OwnerSAPID" *ngIf="req.OwnerSAPID">{{ req.OwnerName }}</span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <div><strong>Opened</strong></div>
                            <span>{{ req.DateCreated | date: 'M/d/yyyy' }}</span>
                        </div>
                        <!-- <div fxLayout="row" fxLayoutAlign="space-between start">
                            <div><strong>Closed</strong></div>
                            <span *ngIf="req.Completed || req.Cancelled">{{ req.DateClosed | date: 'M/d/yyyy' }}</span>
                            <span *ngIf="!req.Completed && !req.Cancelled">N/A</span>
                        </div> -->
                        <div fxLayout="row" fxLayoutAlign="center start" class="margin-bottom">
                            <button
                                type="button"
                                mat-raised-button
                                color="accent"
                                (click)="HandleView(req)"
                                [disabled]="req.Status === 'CANCEL'"
                            >
                                View
                            </button>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="VisibleHeaders"></tr>
            <tr mat-row *matRowDef="let row; columns: VisibleColumns; let $even = even" [class.primarybackground50]="$even"></tr>
        </table>

        <mat-paginator
            #paginator
            [length]="SearchResultsData?.data?.length"
            [pageIndex]="0"
            [pageSize]="SmallDisplay ? 5 : 10"
            [pageSizeOptions]="[5, 10, 25, 100]"
        ></mat-paginator>
    </div>
</div>
